import React, { useEffect } from "react";
import {
  ReadDocumentAsStream,
  DeleteDocumentExpress,
  SubmitDocumentExpress,
} from "../../../features/uploadDocument/uploadDocumentSlice";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import CommonDialog from "../../global/Dialog/CommonDialog";
import { convertfromBase64 } from "../../../common/utils";
import { language } from "../../../features/language/languageSlice";
import { fi } from "date-fns/locale";
import { orderSummarySelector } from "../../../features/ordersSummary/orderSummarySlice";
import { orderLawyerInfoSelector } from "../../../features/auth/orderLawyerInformationSlice";
import { useTranslation } from "react-i18next";
function UploadedFile({
  title,
  file,
  deleteFile,
  name,
  index,
  t,
  userId,
  form = false,
  isDeleteDialogRequired = false,
  isSubmitButtonRequired = false,
  SubmitDocuments,
  field,
  value,
  additionalDocArray,
  docName,
  // propertyList,
  propertyNumber,
  summaryPage,
  popFile,
  setAdditionalDocArray,
  isAdditionalDocumentScreen,
  propertyId,
  documentType,
  requiredDocument,
  propertyPage,
  unifiedQuestion
}) {
  const dispatch = useDispatch();
  const [isDeleteDocDialogOpen, setIsDeleteDocDialogOpen] = useState(false);
  const { editOrderDetails } = useSelector(orderSummarySelector);
  const { fileDetailsInfo } = useSelector(orderLawyerInfoSelector);

const {  i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const viewFile = () => {
    if (summaryPage && file?.Base64String) {
      convertfromBase64(file?.Base64String,file?.name);

    }
    else {
      if (file?.storageFileID > 0 && file?.storageFileID) {
        dispatch(ReadDocumentAsStream(file?.storageFileID, userId, 1));
      } else if (file?.storageFileID === 0 && file?.Base64String) {
        convertfromBase64(file?.Base64String,file?.name);
      }
    }
  };

  const onDeleteDialogConfim = () => {
    if (file?.storageFileID === 0) {
      popFile(name);
    }
    setIsDeleteDocDialogOpen(false);
  };

  const onDeleteDialogCancel = () => {
    setIsDeleteDocDialogOpen(false);
  };

  const removeFile = () => {
    if (summaryPage) {
      popFile(name)
    } else {
      if (isDeleteDialogRequired) {
        setIsDeleteDocDialogOpen(true);
      } else if (file?.storageFileID) {
        deleteFile && deleteFile(name);
        popFile && popFile(name);
        !summaryPage && dispatch(DeleteDocumentExpress(file?.storageFileID, userId));
      } else {
        deleteFile && deleteFile(name);
        popFile && popFile(name);
        if (additionalDocArray?.length > 0) {
          setAdditionalDocArray(additionalDocArray?.map(doc => ({
            ...doc,
            val: doc?.val?.filter(file => file?.name !== name)
          })).filter(doc => doc?.val?.length > 0));
        }
      }
    }
  };
  const propertyList = editOrderDetails?.propertyList;
  let property = propertyList && propertyList?.length > 0 && propertyList[propertyNumber - 1] || [];

  property = !propertyNumber && propertyId != '' && propertyList && propertyList?.length > 0 && propertyList?.filter(x => x?.id === parseInt(propertyId))[0] || property;
  const { address1, cityTown, address2, provinceState, postalZip, displayAddress } = property || {};
  const fullAddress = displayAddress ? (displayAddress + ", " + postalZip) :
    `${address2 ? address2 + ", " : ""}${cityTown ? cityTown + ", " : ""}${provinceState ? provinceState + ", " : ""}${postalZip || ""}`;
  // console.log('propertyyyy', propertyList)
  return (
    <>
      <div key={index} className="mb-3">
        <div className="flex flex-flow justify-between mt-4 group-hover">
          <div className="flex-col">
            <p className="mb-5 font-semibold">{form ? "" : title}</p>
            {isAdditionalDocumentScreen && (
              <p className="font-semibold ml-2 mb-2">{value && value[index]?.storageFileID > 0 ? (currentLanguage==='en'?value[index]?.displayName.split('#')[0]:value[index]?.displayName.split('#')[1]) : documentType + '_' + fullAddress}</p>
            )}
            <p className="flex">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
                <path
                  d="M14 2V8H20"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
                <path
                  d="M16 13H8"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
                <path
                  d="M16 17H8"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
                <path
                  d="M10 9H9H8"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
              {(docName || documentType) && value[index]?.storageFileID === 0
                ? (docName || documentType) +
                "_" +
                (documentType
                  ? (propertyList?.length > 1 ? property?.propertyPosition
                    ? `Property ${property?.propertyPosition}`
                    : "For this order" : "For this order")
                  + " - " + (propertyList?.length > 1 ? fullAddress : '')
                  : fullAddress || "") +
                "_" +
                name
                : name}
            </p>
          </div>
          <div
            className="flex justify-end gap-[16px] self-end mb-6"

          >
            {((isSubmitButtonRequired && file?.storageFileID === 0) ||
              summaryPage || unifiedQuestion || (propertyPage && !file?.legalDescriptionDocStoreExpressID) || (propertyPage && fileDetailsInfo && fileDetailsInfo?.status === "Not Yet Submitted")) && (
                <button
                  type="button"
                  onClick={() => {
                    removeFile();
                  }}
                  style={{ marginRight: localStorage.getItem('selectedLanguage') == "fr" ? 15 : 0 }}
                  className="text-[#E2211C] font-[600] text-[16px] leading-[21.79px] w-[68px] h-[40px] text-center rounded-sm hover:bg-[#ECECEC] focus-visible:bg-[#ECECEC]"
                >
                  {t("delete")}
                </button>
              )}
            {
              <button
                // onClick={() => window.open(URL.createObjectURL(file), "_blank")}
                onClick={() => viewFile()}
                type="button"
                className="btn__secondary text-[#231F20] font-[600] text-[16px] w-[68px] h-[40px] leading-[21.79px] px-[16px] text-center"
              >
                {t("view")}
              </button>
            }
            {requiredDocument && summaryPage &&
              <div className="flex flex-col float-right">
                <button
                  type="button"
                  className="btn__primary flex w-auto py-[10px] pl-4 pr-4"
                  onClick={(e) => { e.target.disabled = true; SubmitDocuments(name, value, field) }}
                >
                  {t("SubmitDocument")}
                </button>

              </div>}
          </div>
        </div>

      </div>
      {
        !summaryPage && additionalDocArray?.length === 0 &&
        file?.storageFileID === 0 && (
          <div className="flex flex-col">
            <div className="flex justify-end mb-3">
              <button
                type="button"
                className="btn__primary flex w-auto py-[10px] pl-4 pr-4"
                onClick={(e) => { e.target.disabled = true; SubmitDocuments(name, value, field) }}
                style={{ marginTop: -15 }}
              >
                {t("SubmitDocument")}
              </button>
            </div>
            {form ? "" : <hr />}
          </div>
        )}
      {isDeleteDocDialogOpen && (
        <CommonDialog
          onCancel={() => onDeleteDialogCancel()}
          onConfirm={() => onDeleteDialogConfim()}
          dialogText={t("AreYouSureDeleteDoc")}
          confirmText={t("yes")}
          cancelText={t("no")}
        />
      )}
    </>
  );
}

export default React.memo(UploadedFile);
